var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenu05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0156 14.4883C17.1797 14.6055 17.25 14.7812 17.2266 15.0156C17.2266 15.2266 17.1328 15.4023 16.9453 15.543L15.2227 17.2656C15.082 17.4297 14.9062 17.5117 14.6953 17.5117C14.5078 17.5117 14.332 17.4297 14.168 17.2656L7.34766 10.4453C6.48047 10.7969 5.57812 10.8789 4.64062 10.6914C3.70312 10.4805 2.88281 10.0234 2.17969 9.32031C1.42969 8.57031 0.960938 7.69141 0.773438 6.68359C0.609375 5.65234 0.75 4.67969 1.19531 3.76562L4.5 7L6.75 4.75L3.51562 1.51562C4.42969 1.09375 5.40234 0.976563 6.43359 1.16406C7.46484 1.32813 8.33203 1.77344 9.03516 2.5C9.76172 3.20312 10.2188 4.02344 10.4062 4.96094C10.6172 5.89844 10.5469 6.80078 10.1953 7.66797L17.0156 14.4883Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu05);
export default __webpack_public_path__ + "static/media/icon_menu_05.3a020764bf07d45f4b263f9d33d0287a.svg";
export { ForwardRef as ReactComponent };